import React from "react";
import Paper from "../components/ui-library/Paper/Paper";
import Img404 from "../assets/img/404-error-img.png";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const StyledContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease;
  &.active {
    padding-left: 160px;
  }
  .link-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    display: inline;
    margin: 0;
    padding: 0;
    color: #8cc13c;
  }
  .link-button:hover {
    text-decoration: underline;
    color: #9f1c84;
  }
  @media (max-width: 1024px) {
    padding: 0rem;
  }
`;

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer id="content" className="container-fluid">
      <div className="row">
        <Paper header={t("appText.notFound.title")}>
          <div
            className="h-100 w-100 d-flex flex-column align-items-center justify-content-around"
            style={{ color: "rgba(0,0,0,0.40)" }}
          >
            <img src={Img404} alt="Not Found" height={"300px"} />
            <div className="text-center" style={{ fontSize: "2.5rem" }}>
              {t("appText.notFound.message")}
            </div>
            <span
              className="text-center"
              style={{ fontSize: "1.3rem" }}
              dangerouslySetInnerHTML={{ __html: t("appText.notFound.info") }}
            />
          </div>
        </Paper>
      </div>
    </StyledContainer>
  );
};

export default NotFound;
